import BaseObject from './BaseObject'

class Clinic extends BaseObject {
  static _primaryKey = 'clinic_id'
  static _apiBaseRoute = 'clinic'
  static _objectType = 'clinic'
  static _isExportable = true
  static _propConfigs = [
    {
      property_name: 'clinic_id'
    },
    {
      property_name: 'name',
      validate: 'required'
    },
    {
      property_name: 'name2'
    },
    {
      property_name: 'abbreviation'
    },
    {
      property_name: 'phone'
    },
    {
      property_name: 'fax'
    },
    {
      property_name: 'account',
      relation_class: null,
      relation_class_loader: async function () {
        return await import('./Account')
      },
      relation_type: BaseObject._relationTypes.hasOne,
      validate: 'required'
    },
    {
      property_name: 'address',
      relation_class: null,
      relation_class_loader: async function () {
        return await import('./Address')
      },
      relation_type: BaseObject._relationTypes.hasOne
    }
  ]
  constructor(row = {}, prefix = '', hasManyPostfix = null) {
    super(row)
    this.prefix = prefix
    this.hasManyPostfix = hasManyPostfix
    if (Object.keys(row).length > 0) {
      this._propConfigs.forEach(propName =>
        this._addPropIfExists(propName, row)
      )
    }
  }
  buildImportableItem = () => {
    const importable = this._clean()
    // make compatibility_class relation
    importable.account = { account_id: this.account.mapped_id }
    if (this.address) {
      importable.address = { address_id: this.address.mapped_id }
    }
    if (this.contact) {
      importable.contact = { contact_id: this.contact.mapped_id }
    }
    importable.non_xtract_clinic = 'F'

    return importable
  }
}

export default Clinic
